<adaa-data-table
    #adaaDataTable
    apiName="getAllV2"
    apiPrefix="entity"
    titleHeader="breadcrumbs.entities"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.ENTITIES"
    [itemTypeId]="Constants.CONSTANT_PERMISSIONS.ENTITIES"
    [customActionButtons]="customButtons"
    (addNewClicked)="addNew()"
    (actionClicked)="getAction($event)"
/>
